import { defineQueryParamHost } from "./queryParamHost";

export const zoomradHost = defineQueryParamHost({
  id: "zoomrad",
  brandId: "zoomrad",
  hostnames: ["zoomrad.insonuchun.uz",
    // "localhost"
  ],
  loginEndpoint: "/MiniApp/ZoomradLogin",
  queryParam: "code",
  payloadKey: "code",
  logoutEndpoint: "/MiniApp/ZoomradLogout",
});
